// extracted by mini-css-extract-plugin
export var adjacentSlide = "_oa-9";
export var arrowButtonContainer = "_oa-5";
export var arrowButtonIcon = "_oa-6";
export var carouselArrowButton = "_oa-2";
export var carouselElementContainer = "_oa-1";
export var currentSlide = "_oa-8";
export var left = "_oa-3";
export var otherSlide = "_oa-a";
export var productCarouselContainer = "_oa-0";
export var right = "_oa-4";
export var sliderOverflow = "_oa-7";